var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWrenchSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F76D57",
    d: "M12.243,60.244c-2.342,2.342-6.143,2.342-8.485-0.001s-2.343-6.142,0.001-8.485l7.793-7.793l8.486,8.485 L12.243,60.244z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45AAB8",
    d: "M21.451,51.036l-8.486-8.485l16.806-16.806c1.773,3.71,4.773,6.711,8.484,8.485L21.451,51.036z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4CCB9",
    d: "M46,34c-8.836,0-16-7.164-16-16S37.164,2,46,2c0.594,0,1.18,0.038,1.758,0.102l-8.83,8.828 c-3.904,3.904-3.904,10.236,0,14.143c3.906,3.906,10.238,3.904,14.143,0l8.83-8.828C61.963,16.82,62,17.406,62,18 C62,26.836,54.838,34,46,34z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M8,53c-1.656,0-3,1.344-3,3s1.344,3,3,3s3-1.344,3-3S9.657,53,8,53z M8,57c-0.553,0-1-0.447-1-1 s0.447-1,1-1s1,0.447,1,1S8.553,57,8,57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#394240",
    d: "M63.652,14.49c-0.277-1.584-1.283-1.544-2.209-0.618s-9.787,9.786-9.787,9.786 c-3.123,3.123-8.189,3.123-11.312-0.001c-3.125-3.124-3.125-8.188,0-11.313c0,0,8.963-8.963,9.787-9.786 c0.822-0.823,0.9-1.901-0.621-2.21C48.375,0.117,47.201,0,46,0c-9.941,0-18,8.06-18,18c0,2.008,0.344,3.933,0.949,5.736 L2.342,50.344c-3.123,3.123-3.123,8.189,0.001,11.313s8.19,3.124,11.313,0.001l26.607-26.607C42.068,35.657,43.992,36,46,36 c9.941,0,18-8.06,18-18C64,16.799,63.852,15.631,63.652,14.49z M12.243,60.244c-2.342,2.342-6.143,2.342-8.485-0.001 s-2.343-6.142,0.001-8.485l7.793-7.793l8.486,8.485L12.243,60.244z M21.451,51.036l-8.486-8.485l16.806-16.806 c1.773,3.71,4.773,6.711,8.484,8.485L21.451,51.036z M46,34c-8.836,0-16-7.164-16-16S37.164,2,46,2 c0.594,0,1.18,0.038,1.758,0.102l-8.83,8.828c-3.904,3.904-3.904,10.236,0,14.143c3.906,3.906,10.238,3.904,14.143,0l8.83-8.828 C61.963,16.82,62,17.406,62,18C62,26.836,54.838,34,46,34z"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#B4CCB9",
    cx: 8,
    cy: 56,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchSvgrepoCom);
export default __webpack_public_path__ + "static/media/wrench-svgrepo-com.2711fbc38ddce27609b34bff8e11cc1b.svg";
export { ForwardRef as ReactComponent };